module.exports = __webpack_public_path__ + "static/media/tokentracker_screenshot.2fe3ff9d.png";